import {gql} from "@apollo/client";

export const GET_BOOKINGS_BY_SYSTEM = gql`
    query getBookingsBySystem($bookingInput: BookingInputSystem!) {
        getBookingsBySystem(bookingInput: $bookingInput) {
            _id
            tourItem {
                _id
                title
            }
            bookingCode
            bookingDate
            status
            language
            priceNet
            tour
            client {
                clientName
                clientCountry
                clientPhone
                clientEmail
                clientAdult
                clientChild
                clientEnfant
                clientYouth
            }
        }
    }
`;

export const COMBINE_BOOKINGS_INTO_TOUR = gql`
    mutation combineBookingsIntoTour($tourCreateInput: TourCreateInput!) {
        combineBookingsIntoTour(tourCreateInput: $tourCreateInput)
    }
`;

export const ADD_BOOKING = gql`
    mutation addBooking($bookingInput: BookingInput!) {
        addBooking(bookingInput: $bookingInput)
    }
`;

export const EDIT_BOOKING = gql`
    mutation editBooking($bookingInput: BookingInput!) {
        editBooking(bookingInput: $bookingInput)
    }
`;
